import $ from 'wee-dom';
import $events from 'wee-events';
import { RouteHandler } from 'wee-routes';
import { _body, _doc, _win } from 'core/variables';
import { tween } from 'shifty';
import $fetch from 'wee-fetch';

function toggleModal() {
	$(_body).toggleClass('-modal');
	$('.modal-container').toggle();
	$('.footer-navigation__item').changeTabindex();
	$('.footer-social__link').changeTabindex();
	$('.footer-privacy__link').changeTabindex();
};

function checkModalRadio(el) {
	const $el = $(el);
	const value = $el.attr('for');

	$el.siblings('label').removeClass('-checked');
	$el.addClass('-checked').prev('value' === value);

	$el.siblings('input')
		.prop('checked', 'false')
		.attr('aria-checked', 'false');

	$el.siblings('input[id=' + value + ']')
		.attr('aria-checked', 'true')
		.prop('checked', 'true');
}

function checkKeyCode(e, el) {
	const $el = $(el);

	if ((e.keyCode === 13 || e.keyCode === 40)) {
		$events.trigger($el, 'click');
	} else if (e.keyCode === 37 || e.keyCode === 39) {
		$el.siblings('label')[0].focus();
	}
}

export default new RouteHandler({
	init() {
		$events.on({
			'.js-schoolType': {
				click(e, el) {
					const $schoolInputs = $('.school-inputs');

					checkModalRadio(el);

					if ($(el).attr('for') === 'atSchool') {
						$schoolInputs.show().find('.modal__input').addClass('-required');
					} else {
						$schoolInputs.hide().find('.modal__input').removeClass('-required');
					}
				},

				keydown(e, el) {
					checkKeyCode(e, el);
				}
			},

			'.js-schoolRole': {
				click(e, el) {
					checkModalRadio(el);
				},

				keydown(e, el) {
					checkKeyCode(e, el);
				}
			},

			'.modal__form': {
				submit(e, el) {
					let schoolRole;
					let schoolName;
					let zipcode;
					let emptyInputs = $('.modal__input.-required').filter((i, el) => {
										return $(el).val() === '';
									});

					if (! $('.school-inputs').hasClass('js-hide') ) {
						const schoolRole = $('.js-school-role:checked').val();
						const schoolName = $('.js-school-name').val();
						const zipcode = $('.js-zipcode').val();
					}

					if (! emptyInputs.length) {
						if ($('.js-email').val() !== $('.js-email-confirm').val()) {
							$('.form-input-error').hide();
							$(el).before($('.js-email-confirm-confirm-error').show());

							e.preventDefault();
						} else {
							if ($('.form-input-error').length) {
								$('.form-input-error').hide();
							}

							$fetch({
								url: 'https://www.abeka.com/ABekaOnline/EmailSubscribe.ashx',
								method: 'post',
								data: {
									signuptype: $('.js-school-type:checked').val(),
									firstname: $('.js-first-name').val(),
									lastname: $('.js-last-name').val(),
									zipcode: $('.js-zipcode').val(),
									emailaddress: $('.js-email').val(),
									emailaddress2: $('.js-email-confirm').val(),
									shortcutcode: 'ABBBLOGEMAILREQ',
									contacttype: schoolRole,
									schoolname: schoolName
								},
								headers: {
									'Content-Type': 'text/plain'
								}
							}).then(() => {
								$('.modal__heading').text('Thank you for signing up!');
								$('.modal__form').hide();
							}).catch((error) => {
								console.log(error);
							});
						}

						e.preventDefault();
					} else {
						const inputName = emptyInputs.eq(0).attr('name');

						$('.form-input-error').hide();
						$(el).before($('.js-' + inputName + '-required-error').show());

						if (! $('.school-inputs').hasClass('js-hide')) {
							if (! $('.js-schoolRole').hasClass('-checked')) {

								$('.form-input-error').hide();
								$(el).before($('.js-contacttype-required-error').show());
							}
						}

						e.preventDefault();
					}
				}
			},

			'.modal__close': {
				click() {
					toggleModal();
				},
				keydown(e) {
					if (e.keyCode === 13 || e.keyCode === 27) {
						toggleModal();
					}
				}
			},

			'.footer-newsletter__button': {
				click() {
					if ($('.footer-newsletter__input').val()) {
						const email = $('.footer-newsletter__input').val();

						$('.modal__input.js-email').val(email);
					}

					toggleModal();
				}
			},

			'.modal-container': {
				click(e, el) {
					if (e.target === el) {
						toggleModal();
					}
				}
			},

			'.footer-newsletter__input': {
				focus: function(e, el) {
					const $input = $(el);

					$('.footer-newsletter__label').hide();
					$input.css('color', 'white');
				},
				blur: function(e, el) {
					const $input = $(el);

					if ($input.val() === '') {
						$('.footer-newsletter__label').show();
					} else {
						$input.css('color', '#7d7d7d');
					}
				}
			},

			'.scroll-top': {
				click: function() {
					tween({
						from: { top: $(_doc).scrollTop() },
						to: { top: 0 },
						duration: 300,
						easing: 'easeOutQuad',
						step: state => {
							$(_doc).scrollTop(state.top);
						}
					})
				}
			}
		});
	}
});